// Curated AU/NZ issuing organisations + nationally-recognised cert codes.
// Mirrors backend/app/data/credential_catalog.py (static seed data — the
// backend copy also serves it via GET /credentials/types for admin tooling).

export const ISSUING_ORGS = [
  { value: 'tafe_qld', label: 'TAFE Queensland', country: 'AU' },
  { value: 'tafe_nsw', label: 'TAFE NSW', country: 'AU' },
  { value: 'tafe_sa', label: 'TAFE SA', country: 'AU' },
  { value: 'south_metro_tafe', label: 'South Metropolitan TAFE (WA)', country: 'AU' },
  { value: 'melbourne_polytechnic', label: 'Melbourne Polytechnic', country: 'AU' },
  { value: 'victoria_university_polytechnic', label: 'Victoria University Polytechnic', country: 'AU' },
  { value: 'tastafe', label: 'TasTAFE', country: 'AU' },
  { value: 'cit', label: 'Canberra Institute of Technology', country: 'AU' },
  { value: 'charles_darwin_university', label: 'Charles Darwin University', country: 'AU' },
  { value: 'french_beauty_academy', label: 'The French Beauty Academy', country: 'AU' },
  { value: 'australasian_college_broadway', label: 'Australasian College Broadway', country: 'AU' },
  { value: 'ato_australia', label: 'ATO — Australia (ABN / business registration)', country: 'AU' },
  { value: 'toi_ohomai', label: 'Toi Ohomai Institute of Technology (NZ)', country: 'NZ' },
  { value: 'ara_institute', label: 'Ara Institute of Canterbury (NZ)', country: 'NZ' },
  { value: 'nz_hito', label: 'NZ Hair & Beauty Industry Training Organisation', country: 'NZ' },
  { value: 'other_international', label: 'Other / International', country: null },
];

export const CERT_CODE_SUGGESTIONS = {
  hairdressing_certificate: [
    { code: 'SHB30416', name: 'Certificate III in Hairdressing' },
    { code: 'SHB40216', name: 'Certificate IV in Hairdressing' },
    { code: 'SHB50216', name: 'Diploma of Salon Management' },
    { code: 'SHB30516', name: 'Certificate III in Barbering' },
  ],
  beauty_therapy_certificate: [
    { code: 'SHB30121', name: 'Certificate III in Beauty Services' },
    { code: 'SHB40121', name: 'Certificate IV in Beauty Therapy' },
    { code: 'SHB50121', name: 'Diploma of Beauty Therapy' },
  ],
  nail_technician_certificate: [
    { code: 'SHB30321', name: 'Certificate III in Nail Technology' },
  ],
  makeup_artistry_certificate: [
    { code: 'SHB30221', name: 'Certificate III in Make-Up' },
    { code: 'CUA51015', name: 'Diploma of Screen and Media (Specialist Make-up)' },
  ],
  skin_care_certificate: [
    { code: 'SHB40121', name: 'Certificate IV in Beauty Therapy (skin specialisation)' },
    { code: '52850WA', name: 'Advanced Diploma of Cosmetic Dermal Science' },
  ],
  massage_therapy_certificate: [
    { code: 'HLT42021', name: 'Certificate IV in Massage Therapy' },
    { code: 'HLT52021', name: 'Diploma of Remedial Massage' },
  ],
  cosmetic_tattoo_certificate: [
    { code: 'SHBBSKS005', name: 'Design and provide cosmetic tattooing (unit)' },
  ],
  first_aid_certificate: [
    { code: 'HLTAID011', name: 'Provide First Aid' },
    { code: 'HLTAID009', name: 'Provide CPR' },
  ],
  business_license: [
    { code: 'ABN', name: 'Australian Business Number (sole trader / business)' },
    { code: 'NZBN', name: 'New Zealand Business Number' },
  ],
  insurance_certificate: [
    { code: 'PL-PI', name: 'Public Liability + Professional Indemnity policy' },
  ],
};

export const OTHER_INTERNATIONAL = 'other_international';
